import { Merge } from 'type-fest'

import { DipsSchemas } from '~/clients/dips-client'

export type DipsCriticalInformationPatient = DipsSchemas['PatientCriticalInformation']
export type UnifiedDipsCriticalInformation = Merge<{ entity_type: 'dips_critical_information' }, DipsCriticalInformationPatient>

export function transformDipsCriticalInformation(criticalInformation: DipsCriticalInformationPatient[]): UnifiedDipsCriticalInformation[] {
    return criticalInformation.map(criticalInformation => ({
        ...criticalInformation,
        entity_type: 'dips_critical_information',
    }))
}
